import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import FormSocialButton from './FormSocialButton'
import { profileSelector } from '../reducers/profile'
import { sessionTokenSelector } from '../reducers/session'
import {
  getAccount,
  postGoogleAuthorize,
  deleteGoogleUnauthorize,
  postFacebookAuthorize,
  deleteFacebookUnauthorize,
  deleteVkUnauthorize,
  deleteAppleUnauthorize
} from '../actions/api'
import get from 'lodash/get'

function SocialForm({
  profile,
  getAccount,
  postGoogleAuthorize,
  deleteGoogleUnauthorize,
  postFacebookAuthorize,
  deleteFacebookUnauthorize,
  deleteVkUnauthorize,
  deleteAppleUnauthorize,
  appleFail,
  vkFail,
  sessionToken
}) {
  const [loading, setLoading] = useState({ google: false, facebook: false, vk: false, apple: false })
  const [error, setError] = useState({ google: null, facebook: null, vk: null, apple: null })
  // const [isFacebookProcessing, setFacebookProcessing] = useState(false)

  useEffect(() => {
    setError({ ...error, apple: appleFail, vk: vkFail })
  }, [appleFail, vkFail])

  useEffect(() => {
    if (typeof window.gapi !== 'undefined' && process.env.REACT_APP_GOOGLE_CLIENT_ID) {
      window.gapi.load('client:auth2', initGoogleClient)
    }
  })

  let googleAuth

  const initGoogleClient = () => {
    window.gapi.client.init({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      scope: 'profile'
    })
    googleAuth = window.gapi.auth2.getAuthInstance()
  }

  const handleGoogleAuthorizeClick = async () => {
    setError({ ...error, google: null })
    try {
      const user = await googleAuth.signIn()
      const profile = user.getBasicProfile()
      setLoading({ ...loading, google: true })
      const response = await postGoogleAuthorize({
        id_token: user.getAuthResponse().id_token,
        user_id: profile.getId(),
        email: profile.getEmail(),
        name: profile.getName()
      })
      await getAccount()
      setLoading({ ...loading, google: false })
      if (response.payload.error || response.error) {
        setError({
          ...error,
          google: String(response.payload.error || response.payload.message || response.error)
        })
      }
    } catch (error) {
      if (error.error !== 'popup_closed_by_user') {
        setLoading({ ...loading, google: false })
        setError({ ...error, google: String(error) })
      }
    }
  }

  // const handleFacebookAuthorizeClick = () => {
  //   setError({ ...error, facebook: null })
  //
  //   if (!window.FB || isFacebookProcessing) {
  //     return
  //   }
  //
  //   setFacebookProcessing(true)
  //   window.FB.login(
  //     async fbResponse => {
  //       setFacebookProcessing(false)
  //       if (fbResponse.status === 'connected') {
  //         try {
  //           setLoading({ ...loading, facebook: true })
  //           const response = await postFacebookAuthorize({ access_token: fbResponse.authResponse.accessToken })
  //           await getAccount()
  //           setLoading({ ...loading, facebook: false })
  //           if (response.payload.error || response.error) {
  //             setError({
  //               ...error,
  //               facebook: String(response.payload.error || response.payload.message || response.error)
  //             })
  //           }
  //         } catch (error) {
  //           setLoading({ ...loading, facebook: false })
  //           setError({ ...error, facebook: String(error) })
  //         }
  //       }
  //     },
  //     { auth_type: 'rerequest', scope: 'email,public_profile' }
  //   )
  // }

  const handleVkAuthorizeClick = () => {
    window.location = `${process.env.REACT_APP_AUTHORIZE_HOST}/radio/profile/vk_authorize?web=1&session_jwt=${sessionToken}`
  }

  const handleAppleAuthorizeClick = () => {
    window.location = `${process.env.REACT_APP_AUTHORIZE_HOST}/radio/profile/apple_authorize?web=1&session_jwt=${sessionToken}`
  }

  const handleonUnauthorizeClick = name => async () => {
    setError({ ...error, [name]: null })
    try {
      setLoading({ ...loading, [name]: true })
      let response
      switch (name) {
        case 'facebook':
          response = await deleteFacebookUnauthorize()
          break
        case 'vk':
          response = await deleteVkUnauthorize()
          break
        case 'apple':
          response = await deleteAppleUnauthorize()
          break
        default:
          response = await deleteGoogleUnauthorize()
          break
      }
      await getAccount()
      setLoading({ ...loading, [name]: false })
      if (response.payload.error || response.error) {
        setError({ ...error, [name]: String(response.payload.error || response.payload.message || response.error) })
      }
    } catch (error) {
      setLoading({ ...loading, [name]: false })
      setError({ ...error, [name]: String(error) })
    }
  }

  const authorizationGoogle = get(profile, 'googleIdentity.name')
  const authorizationApple = get(profile, 'appleIdentity')
  
  return (
    <div className="account-block account-block--separated account-block--padding-small">
      <div className="account-block__title">Внешние сервисы</div>
      {authorizationGoogle && (
        <FormSocialButton
          provider="google"
          label="Google"
          isSettings
          loading={loading.google}
          error={error.google}
          onAuthorizeClick={handleGoogleAuthorizeClick}
          authorization={authorizationGoogle}
          onUnauthorizeClick={handleonUnauthorizeClick('google')}
        />
      )}
      {/*<FormSocialButton*/}
      {/*  provider="facebook"*/}
      {/*  label="Facebook"*/}
      {/*  isSettings*/}
      {/*  loading={loading.facebook}*/}
      {/*  error={error.facebook}*/}
      {/*  onAuthorizeClick={handleFacebookAuthorizeClick}*/}
      {/*  authorization={get(profile, 'facebookIdentity.name')}*/}
      {/*  onUnauthorizeClick={handleonUnauthorizeClick('facebook')}*/}
      {/*/>*/}
      <FormSocialButton
        provider="vk"
        label="VK"
        isSettings
        loading={loading.vk}
        error={error.vk}
        onAuthorizeClick={handleVkAuthorizeClick}
        authorization={get(profile, 'vkIdentity.name')}
        onUnauthorizeClick={handleonUnauthorizeClick('vk')}
      />
      {authorizationApple && (
        <FormSocialButton
          provider="apple"
          label="Apple"
          isSettings
          loading={loading.apple}
          error={error.apple}
          onAuthorizeClick={handleAppleAuthorizeClick}
          authorization={authorizationApple}
          appleAuthorizationName={get(profile, 'appleIdentity.name')}
          onUnauthorizeClick={handleonUnauthorizeClick('apple')}
        />
      )}
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  sessionToken: sessionTokenSelector
})

export default connect(mapStateToProps, {
  getAccount,
  postGoogleAuthorize,
  postFacebookAuthorize,
  deleteGoogleUnauthorize,
  deleteFacebookUnauthorize,
  deleteVkUnauthorize,
  deleteAppleUnauthorize
})(SocialForm)
